'use strict';

(function () {
  'use strict';

  angular.module('msUtility').service('pagingSvc', pagingSvc);

  pagingSvc.$inject = ['$q'];

  /* @ngInject */
  function pagingSvc($q) {
    var pagingCache = {};
    return {
      getPage: getPage
    };

    ////////////////

    /**
     * This keeps track of the paging of a function call.
     * @param {String} key This is the key that uniquely identifies what belongs together for paging.
     * @param {Function} fn The second argument of getPage should be a function.
     * This function is expected to accept a page number as the last parameter, and is expected to return a promise.
     * The rest of the arguments passed to getPage will be forwarded to the function.
     *
     * @return {[type]} [description]
     */
    function getPage() {
      // the first argument should be the function we want to call.
      // The rest of the arguments will be forwarded on to the function, but we don't want to send the function to itself later
      var key = [].shift.apply(arguments);
      var fn = [].shift.apply(arguments);
      // the best way to uniquely identify the caching item is to look for function exact equality
      // We could possibly replace this by having the consumers pass in a key to the function
      var cache = pagingCache[key];
      if (angular.isUndefined(cache)) {
        cache = {
          function: fn,
          page: 0,
          values: [],
          inProgress: false,
          finished: false
        };
        pagingCache[key] = cache;
      }
      // we reject so that the consumers don't set the value when it's not necessary
      if (cache.inProgress) {
        return $q.reject('loading');
      }
      if (cache.finished) {
        return $q.when(cache.values);
      }
      cache.inProgress = true;
      // add the paging as the last argument
      [].push.call(arguments, cache.page);
      return fn.apply(null, arguments).then(function (resp) {
        cache.inProgress = false;
        cache.page++;
        cache.values = cache.values.concat(resp);
        if (resp.length === 0) {
          cache.finished = true;
        }
        return cache.values;
      }).finally(function () {
        return cache.inProgress = false;
      });
    }
  }
})();